import { render, staticRenderFns } from "./VideoModuleSetting.vue?vue&type=template&id=5a49065c&scoped=true&"
import script from "./VideoModuleSetting.vue?vue&type=script&lang=js&"
export * from "./VideoModuleSetting.vue?vue&type=script&lang=js&"
import style0 from "./VideoModuleSetting.vue?vue&type=style&index=0&id=5a49065c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a49065c",
  null
  
)

export default component.exports